import { createFileRoute } from '@tanstack/react-router';

export interface TemplatesListSearch {
  page?: number
  form_types?: string
  countries?: string
  entity_types?: string
  updated_after?: string
  updated_before?: string
  created_by?: string
  is_active?: boolean | null
  search?: string
  search_content?: boolean
  sort?: string
  order?: 'asc' | 'desc'
}

export const Route = createFileRoute('/template-engine/templates/')({
  validateSearch: (search: Record<string, unknown>): TemplatesListSearch => ({
    page: typeof search.page === 'number' && search.page > 1 ? search.page : undefined,
    form_types: typeof search.form_types === 'string' ? search.form_types : undefined,
    countries: typeof search.countries === 'string' ? search.countries : undefined,
    entity_types: typeof search.entity_types === 'string' ? search.entity_types : undefined,
    updated_after: typeof search.updated_after === 'string' ? search.updated_after : undefined,
    updated_before: typeof search.updated_before === 'string' ? search.updated_before : undefined,
    created_by: typeof search.created_by === 'string' ? search.created_by : undefined,
    is_active:
      search.is_active === true ? true :
      search.is_active === false ? false :
      search.is_active === null ? null :
      // backward compat: legacy string-encoded URLs (is_active=%22true%22 etc.)
      search.is_active === 'true' ? true :
      search.is_active === 'false' ? false :
      search.is_active === 'all' ? null :
      undefined,
    search: typeof search.search === 'string' ? search.search : undefined,
    // Normalised to a boolean like `is_active` above. `lib/filters` encodes a `toggle` as a real
    // boolean; the string form is the legacy encoding, kept so old links stay valid.
    search_content:
      search.search_content === true || search.search_content === 'true' ? true : undefined,
    sort: typeof search.sort === 'string' ? search.sort : undefined,
    order: search.order === 'asc' || search.order === 'desc' ? search.order : undefined,
  }),
});
